<div class="wrapper">
    <form #form="ngForm" autocomplete="off">
        <div class="row-wrapper">
            <div *ngFor="let weekDay of weekDays">
                <div>{{ weekDay | appTranslate }}</div>
            </div>
        </div>
        <div class="row-wrapper" *ngFor="let requestDays of requestDaysGrouped">
            <div *ngFor="let _ of weekDays; let weekDay = index">
                <div *ngIf="getDayRequest(requestDays, weekDay)">
                    <mat-form-field class="day-input">
                        <mat-label>{{ getDayRequest(requestDays, weekDay)?.shortDateString }}</mat-label>
                        <input
                            type="text"
                            [name]="'requestDay' + getDayRequest(requestDays, weekDay)?.shortDateString"
                            matInput
                            [(ngModel)]="getDayRequest(requestDays, weekDay).amount"
                            [min]="0"
                            [max]="maxAmount"
                            [textMask]="{ mask: twoDecimalPointsNumberMask }"
                        />
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="error-wrapper">
            <mat-error *ngIf="!isValid">{{
                'time-off-v3.theAmountPerDayShouldBeBetween' | translate: { max: maxAmount }
            }}</mat-error>
        </div>
    </form>
</div>
